export default __webpack_public_path__ + "static/media/chestguard_of_the_vanguard.a998ed6d.jpg";